import React, { useEffect, useState } from 'react';
import { publisherTicketsAPI } from '../../utils/api';
import Swal from 'sweetalert2';
import api from '../../utils/api';

const STATUS_COLOR = { OPEN: '#f59e0b', IN_PROGRESS: '#0ea5e9', RESOLVED: '#059669', CLOSED: '#94a3b8' };

export default function PublisherTicketsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ subject: '', description: '' });
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    publisherTicketsAPI.list()
      .then(r => setRows(Array.isArray(r.data) ? r.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const submit = async e => {
    e.preventDefault();
    if (!form.subject.trim()) return;
    setSaving(true);
    try {
      await api.post('/api/publisher/me/tickets', form);
      setForm({ subject: '', description: '' });
      setShowForm(false);
      load();
      Swal.fire({ icon: 'success', title: 'Ticket submitted', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
    } catch (e) {
      Swal.fire('Error', e.response?.data?.error || e.message, 'error');
    } finally { setSaving(false); }
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0 }}>Support Tickets</h2>
          <p style={{ color: '#888', margin: '4px 0 0' }}>Submit issues or requests to the admin team</p>
        </div>
        <button className="eduss-btn eduss-btn-primary" onClick={() => setShowForm(s => !s)}>
          {showForm ? 'Cancel' : '+ New Ticket'}
        </button>
      </div>

      {showForm && (
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,.08)', marginBottom: 24 }}>
          <h4 style={{ marginBottom: 16 }}>New Support Ticket</h4>
          <form onSubmit={submit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Subject *</label>
              <input className="eduss-input" value={form.subject} onChange={e => setForm(f => ({ ...f, subject: e.target.value }))}
                placeholder="Brief description of the issue" required style={{ width: '100%' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Details</label>
              <textarea className="eduss-input" rows={4} value={form.description}
                onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
                placeholder="Provide more context…" style={{ width: '100%', resize: 'vertical' }} />
            </div>
            <button type="submit" className="eduss-btn eduss-btn-primary" disabled={saving}>
              {saving ? 'Submitting…' : 'Submit Ticket'}
            </button>
          </form>
        </div>
      )}

      {loading ? <p>Loading…</p> : rows.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '48px 0', color: '#aaa' }}>
          <div style={{ fontSize: 40 }}>🎫</div>
          <p style={{ marginTop: 8 }}>No tickets yet. Create one above.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {rows.map(t => (
            <div key={t.id} style={{ background: '#fff', borderRadius: 10, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,.07)', borderLeft: `4px solid ${STATUS_COLOR[t.status] || '#cbd5e1'}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{t.subject}</div>
                  {t.description && <div style={{ color: '#666', fontSize: 13, marginTop: 4 }}>{t.description}</div>}
                </div>
                <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20, background: `${STATUS_COLOR[t.status]}22`, color: STATUS_COLOR[t.status] || '#94a3b8', whiteSpace: 'nowrap', marginLeft: 12 }}>
                  {t.status || 'OPEN'}
                </span>
              </div>
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 8 }}>
                #{t.id} · {t.created_at ? new Date(t.created_at).toLocaleDateString('en-US', { year:'numeric', month:'short', day:'numeric' }) : '—'}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
